module.exports = __webpack_public_path__ + "media/images/xc_9-81e3515db446770c647240d0fa36e110.png";